import { Button } from "Components/General/Button";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { Tooltip } from "antd";
import { useEffect, useState } from "react";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";

export const AdminDBMigration = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkForMigrations = async () => {
    try {
      const response = await API.getData<API_AdminMigrationMeetings>(
        API_URL.ADMIN_MIGRATION.getNumberOfMeetingsToMigrate()
      );
      if (response?.numberOfMeetings) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    } catch (error) {
      throw error;
    }
  };

  const handleMigrate = async () => {
    try {
      setLoading(true);
      await API.newData<API_AdminMigrationMeetings>(API_URL.ADMIN_MIGRATION.patchMeetingProtocols(), {});
      await checkForMigrations();
      notificationSuccess("Success", "Migration of meeting protocols was finished");
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkForMigrations();
  }, []);

  return isVisible ? (
    <Tooltip title="Script for one-time conversion of minutes PDFs for existing Meetings">
      <Button onClick={handleMigrate} loading={loading}>
        Migrate
      </Button>
    </Tooltip>
  ) : (
    <div />
  );
};
